

import { mainActions } from "../service/store/main/actions";
import { RootState } from "../service/store/types/RootState";
import Vue, { PluginObject } from "vue";
import { Store } from "vuex";
import { AuthRole } from "@service/types/AuthRole";

export interface FeatureAccessPluginInterface extends PluginObject<FeatureAccessPluginInterface> {
    check(featureName: string): boolean;
}

export class FeatureAccessPlugin implements FeatureAccessPluginInterface {

    featuresList: Record<string, any> = {
        sendComment: {
            name: "sendComment",
            allowedForAnon: false
        }
    }

    constructor(
        private readonly $store: Store<RootState>
    ) {
    }

    /**
     * make featureName as key of featuresList
     */
    check(featureName: string): boolean {

        const currentStatus: AuthRole | string = this.getCurrentRole();

        console.log("checking...");
        console.log(`current status is ${currentStatus}`);

        if (currentStatus === AuthRole.anonymous) {
            //check the list of features

            const allowedForAnon = this.featuresList[featureName]?.allowedForAnon;

            if (!allowedForAnon) {
                this.showAnonymAuth();
            }

            return allowedForAnon;
        }
        else {
            return this.checkPermisions(featureName);
        }
    }

    private getCurrentRole(): AuthRole | string {
        return this.$store.state.session.roleId;
    }

    private showAnonymAuth() {
        this.$store.dispatch(mainActions.setAnonymAuthVisibility, true);
    }

    private checkPermisions(featureName: string) {
        return true
        // things about paymentAccess
    }

    install() {
        Vue.prototype.$featureAccess = this;
    }
}